import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FaAngleDown from 'react-icons/lib/fa/angle-down';

// inner imports
import { BAND, MUSICIAN } from "../../../consts";
import { capitalizeAll } from '../../../utils';

// import css
import './AccordionDropDown.css';


class AccordionDropDown extends Component {
    constructor() {
        super();
        this.state = {
            leftItemIndex: 0,
            isOpen: false
        }
    }

    getType() {
        return this.props.type === BAND ? BAND : MUSICIAN;
    }

    selectOption (option) {
        if (this.props.onMultipleSelect) {
            this.props.onMultipleSelect(option);
            return;
        }

        this.props.onSingleSelect(option);
    }

    unSelectOption(option) {
        if (!this.props.onMultipleUnSelect) return;

        this.props.onMultipleUnSelect(option);
    }

    renderOptions() {
        if (!this.props.options) return null;

        return this.props.options.map((o, i) => {
            let selected = '';
            let firstSelected = '';
            let onClickHandler = opt => this.selectOption(opt);

            if (this.props.selectedMany && this.props.selectedMany.indexOf(o.name) > -1) {
                selected = 'selected';
                onClickHandler = opt => this.unSelectOption(opt);

            } else if (this.props.selectedOption && this.props.selectedOption.name === o.name) {
                if (i !== 0) {
                    selected = 'selected';
                } else {
                    firstSelected = 'selected';
                }

            }

            const isAllSelected = Object.keys(this.props.selectedOption || {}).length < 1 && (!this.props.selectedMany || this.props.selectedMany.length < 1);

            if (i === 0) {
                return ([
                    <li
                        key={o.name + '-all-' + i}
                        className={`option ${this.props.type} ${isAllSelected ? 'selected' : ''}`}
                        onClick={() => onClickHandler({})}
                    >
                        הכל
                    </li>,
                    <li
                        key={o.name + i}
                        className={`option ${this.props.type} ${selected || firstSelected}`}
                        onClick={() => onClickHandler(o)}
                    >
                        {capitalizeAll(o.singular)}
                    </li>
                ])
            }

            return (
                <li
                    key={o.name + i}
                    className={`option ${this.props.type} ${selected}`}
                    onClick={() => onClickHandler(o)}
                >
                    {capitalizeAll(o.singular)}
                </li>
            )
        })
    }

    render () {
        document.body.style.overflow = this.state.isOpen ? 'hidden' : 'initial';

        //  style={{maxHeight: window.innerHeight / 2.5}}
        return (
            <div className="accordion-drop-down-wrapper">
                <div className={`header-wrapper ${this.props.type}`} onClick={() => this.setState({ isOpen: !this.state.isOpen})}>
                    <p className="title">{this.props.title}</p>
                    <i className="mobile-arrow"><FaAngleDown /></i>
                </div>
                <div className="dropdown-content rtl" style={{maxHeight: window.innerHeight / 2.5}}>
                    <ul className={`options-list ${this.state.isOpen ? 'open' : ''}`}>
                        {this.renderOptions()}
                    </ul>
                </div>
            </div>
        )
    }
}

AccordionDropDown.propTypes = {
    title: PropTypes.string,
    type: PropTypes.string,
    onMultipleSelect: PropTypes.func,
    onMultipleUnSelect: PropTypes.func,
    selectedMany: PropTypes.array,
    onSingleSelect: PropTypes.func,
    selectedOption: PropTypes.oneOfType([
        PropTypes.string
    ]),
    options: PropTypes.array,

    datatypes: PropTypes.object,
    userShouldEnter: PropTypes.array,
    onSelect: PropTypes.func,
    toggleAllTypes: PropTypes.func,
    isDark: PropTypes.bool,
    isOpposite: PropTypes.bool
};

export default AccordionDropDown;



// WEBPACK FOOTER //
// ./src/Components/Elements/Mobile/AccordionDropDown.js